module.exports = "pegasus/assets/blocks/column-6-theme4.png";